import { render, staticRenderFns } from "./PartyRegistrationModal.vue?vue&type=template&id=5954008b&scoped=true&"
import script from "./PartyRegistrationModal.vue?vue&type=script&lang=js&"
export * from "./PartyRegistrationModal.vue?vue&type=script&lang=js&"
import style0 from "./PartyRegistrationModal.vue?vue&type=style&index=0&id=5954008b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5954008b",
  null
  
)

export default component.exports